import React from "react"

import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import { Container, Row, Col } from "react-grid-system"
import SEO from "../components/seo"
import ProfileCards from "../components/story/ProfileCards"
import { Header1, Button } from "../elements"
import { rhythm } from "../../config/typography"
import { below } from "../../config/utilities"
import BGImageBlog from "../elements/BGImageBlog"
import TransitionContext from "../context/TransitionContext"

const Story = props => {
  const data = useStaticQuery(graphql`
    query andrewpatrick {
      allMdx(
        filter: { fileAbsolutePath: { regex: "/profiles/" } }
        sort: { fields: frontmatter___name, order: ASC }
      ) {
        totalCount
        edges {
          node {
            id
            frontmatter {
              name
              flexDir
              text
              textTwo
              textThree
              text2
              headshot {
                childImageSharp {
                  fluid(maxWidth: 600, grayscale: true, fit: COVER) {
                    ...GatsbyImageSharpFluid_tracedSVG
                  }
                }
              }
            }
          }
        }
      }
      file(absolutePath: { regex: "/profiles/PAKD1/" }) {
        id
        childImageSharp {
          id
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `)
  const { edges: profiles } = data.allMdx
  const image = data.file
  return (
    <>
      <SEO
        title="Story"
        pathname={props.location.pathname}
        description="Read more about PAKD Media's origin story, their vision for the future of motion and design, and the company mission that drives it all."
      />
      <TransitionContext location={props.location}>
        <Container fluid style={{ padding: 0 }}>
          <Row justify="center" align="center">
            <Col xs={12}>
              <ImagesWrap>
                <BGImageBlog
                  bgColor={`${props => props.theme.brand.primary}`}
                  imageData={image.childImageSharp.fluid}
                />
              </ImagesWrap>
            </Col>
          </Row>

          <Row justify="center" align="center" className=" padbtm padtop ">
            <Col sm={6} xs={6}>
              <Header1
                lineOne="Story"
                lineTwo="Small but mighty."
                marginbottom={`0`}
              />
            </Col>
          </Row>
          <Row
            justify="center"
            align="center"
            style={{ marginBottom: `${rhythm(1.5)}` }}
          >
            <Col md={8} sm={10} xs={10}>
              <CardsPara>
                The founders of PAKD Media have spent the last decade building
                in-house creative teams at various marketing and tech companies,
                fostering an environment where creatives could contribute unique
                solutions to cross-organizational problems.
              </CardsPara>
              <CardsPara>
                Their vision of integrated creative services laid the foundation
                for PAKD Media.
                <strong>
                  &nbsp;We're here to give those ethereal, way-far-off, "maybe
                  next year" ideas a little push
                </strong>
                , and when the momentum kicks in, leverage our technical and
                creative proficiencies to make them a reality.
              </CardsPara>
              <CardsPara>
                Our team consistently delivers collateral that performs.
                Together, we'll push against boundaries that you and your team
                may not even have known existed, and together we'll build a
                brand experience as focused as you are.
              </CardsPara>
              <CardsPara>
                At PAKD, no idea is final and no design is complete. We believe
                the only perfect solution is the incessant pursuit of something
                bigger and bolder. That
                <strong>
                  &nbsp;branding shouldn't just help our clients look better,
                  but be better.
                </strong>
                {` `}
                That the goal shouldn't be to just "get it done", but to make it
                great.
              </CardsPara>
              <CardsPara>
                So to all those naysayers out there who told you not to reinvent
                the wheel, we say dream big, because with PAKD on your team,
                we'll build content that's
                <strong> uniquely creative</strong> and{` `}
                <strong>tenaciously compelling</strong>.
                <br />
                <br />
                ❤️ - PAKD Media
              </CardsPara>
            </Col>
          </Row>

          <CardsWrap>
            <div className="innerwrap">
              <Row justify="center" align="center" className=" padbtm padtop ">
                <Col xs={12}>
                  <Header1
                    lineOne="Leadership "
                    lineTwo="PAKD Media's Founders"
                    marginbottom={`0`}
                    secondary
                  />
                </Col>
              </Row>
              {profiles.map(profile => (
                <ProfileCards
                  key={profile.node.frontmatter.name}
                  profile={profile}
                />
              ))}
              <Row
                align="center"
                justify="center"
                style={{ paddingBottom: `${rhythm(3.5)}` }}
              >
                <Col>
                  <Button linkTo="/contact" secondary>
                    Contact Us
                  </Button>
                </Col>
              </Row>
            </div>
          </CardsWrap>
        </Container>
      </TransitionContext>
    </>
  )
}
export default Story

const CardsWrap = styled.div`
  margin-top: 0 auto;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.primarydark};
  padding: 0;
`
const CardsPara = styled.p`
  margin: ${rhythm(1)} auto;
  max-width: 80ch;
  &:first-of-type {
    margin-top: 0;
  }
`
const ImagesWrap = styled.div`
  background: #0f1524;
  width: 100vw;
  height: 600px;
  ${below.s`
    height:500px;
    `}
  ${below.xs`
    height:400px;
    `}
`
